import { Component, Input } from "@angular/core";

@Component({
  selector: "ngx-view-rating-star",
  styleUrls: ["./view-rating-star.component.scss"],
  templateUrl: "./view-rating-star.component.html",
})
export class ViewRatingStarComponent {
  @Input() rating: number;
  @Input() noRating?: number;

  constructor() {}
}
